<template>
  <vx-card title="SARS-CoV-2 Variant distribution across major regions">
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="false" color="#007BFF" loader="dots"></loading>

    <div class="vx-row mb-base">
      <div class="vx-col w-full md:w-1/3 flex flex-col lg:mb-0 md:mb-base sm:mb-0 mb-base">
        <vue-apex-charts type="donut" height="340" class="mb-12 mt-4" :options="kchartOptions" :series="kseries" />
      </div>
      <div class="vx-col w-full md:w-1/3 flex flex-col lg:mb-0 md:mb-base sm:mb-0 mb-base">
        <vue-apex-charts type="donut" height="340" class="mb-12 mt-4" :options="cchartOptions" :series="cseries" />
      </div>
      <div class="vx-col w-full md:w-1/3 flex flex-col lg:mb-0 md:mb-base sm:mb-0 mb-base">
        <vue-apex-charts type="donut" height="340" class="mb-12 mt-4" :options="gchartOptions" :series="gseries" />
      </div>
    </div>
    <div class="vx-row mb-base">
      <div class="vx-col w-full md:w-1/3 flex flex-col lg:mb-0 md:mb-base sm:mb-0 mb-base">
        <vue-apex-charts type="donut" height="340" class="mb-12 mt-4" :options="achartOptions" :series="aseries" />
      </div>
      <div class="vx-col w-full md:w-1/3 flex flex-col lg:mb-0 md:mb-base sm:mb-0 mb-base">
        <vue-apex-charts type="donut" height="340" class="mb-12 mt-4" :options="tchartOptions" :series="tseries" />
      </div>
      <div class="vx-col w-full md:w-1/3 flex flex-col lg:mb-0 md:mb-base sm:mb-0 mb-base">
        <vue-apex-charts type="donut" height="340" class="mb-12 mt-4" :options="tkchartOptions" :series="tkseries" />
      </div>
    </div>
  </vx-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import DateSliderFilter from '../filters/DateSliderFilter.vue'
// import FancyDateSliderFilter from '../filters/FancyDateSliderFilter.vue'

import covidApi from '@/http/requests/covid/index.js'

const numeral = require('numeral')

export default {
  name: 'FourDonuts',
  components: {
    Loading,
    VueApexCharts,
    DateSliderFilter
    // FancyDateSliderFilter
  },
  computed: {
    isLoading() {
      return this.isLoadingG && this.isLoadingA && this.isLoadingK && this.isLoadingT && this.isLoadingTK && this.isLoadingC
    }
  },
  data() {
    return {
      strains: [],
      gseries: [],
      aseries: [],
      kseries: [],
      tseries: [],
      cseries: [],
      tkseries: [],
      gchartOptions: {
        labels: [],
        colors: ['#008cff', '#28C76F', '#EA5455', '#7193FF', '#FF9F43','#e5ff00', '#1E1E1E', '#4b9484', '#af9d6a'],
        dataLabels: {
          enabled: false
        },
        legend: { show: true, position: 'bottom' },
        tooltip: {
          y: {
            formatter(val, w) {
              const sum = w.globals.seriesTotals.reduce((a, b) => {
                return a + b
              }, 0)
              const x = sum === 0 ? 0 : Math.round((val / sum) * 100)
              return `${x}%`
            }
          }
        },
        chart: {
          offsetY: 80,
          type: 'donut',
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          pie: {
            customScale: 1.0,
            donut: {
              labels: {
                show: true,
                name: { show: true },
                value: {
                  show: true,
                  formatter(val) {
                    return numeral(val).format('0,0')
                  }
                },
                total: {
                  showAlways: true,
                  label: 'Eastern',
                  show: true
                }
              }
            }
          }
        },
        stroke: { width: 0 }
      },
      achartOptions: {
        labels: [],
        colors: ['#008cff', '#28C76F', '#EA5455', '#7193FF', '#FF9F43', '#e5ff00', '#1E1E1E', '#4b9484', '#af9d6a'],
        dataLabels: {
          enabled: false
        },
        legend: { show: true, position: 'bottom' },
        tooltip: {
          y: {
            formatter(val, w) {
              const sum = w.globals.seriesTotals.reduce((a, b) => {
                return a + b
              }, 0)
              const x = sum === 0 ? 0 : Math.round((val / sum) * 100)
              return `${x}%`
            }
          }
        },
        chart: {
          offsetY: 80,
          type: 'donut',
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          pie: {
            customScale: 1.0,
            donut: {
              labels: {
                show: true,
                name: { show: true },
                value: { show: true },
                total: {
                  showAlways: true,
                  label: 'Greater Accra',
                  show: true
                }
              }
            }
          }
        },
        stroke: { width: 0 }
      },
      kchartOptions: {
        labels: [],
        colors: ['#008cff', '#28C76F', '#EA5455', '#7193FF', '#FF9F43', '#e5ff00', '#1E1E1E', '#4b9484', '#af9d6a'],
        dataLabels: {
          enabled: false
        },
        legend: { show: true, position: 'bottom' },
        tooltip: {
          y: {
            formatter(val, w) {
              const sum = w.globals.seriesTotals.reduce((a, b) => {
                return a + b
              }, 0)
              const x = sum === 0 ? 0 : Math.round((val / sum) * 100)
              return `${x}%`
            }
          }
        },
        chart: {
          offsetY: 80,
          type: 'donut',
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          pie: {
            customScale: 1.0,
            donut: {
              labels: {
                show: true,
                name: { show: true },
                value: { show: true },
                total: {
                  showAlways: true,
                  label: 'Ashanti',
                  show: true
                }
              }
            }
          }
        },
        stroke: { width: 0 }
      },
      tchartOptions: {
        labels: [],
        colors: ['#008cff', '#28C76F', '#EA5455', '#7193FF', '#FF9F43', '#e5ff00', '#1E1E1E', '#4b9484', '#af9d6a'],
        dataLabels: {
          enabled: false
        },
        legend: { show: true, position: 'bottom' },
        tooltip: {
          y: {
            formatter(val, w) {
              const sum = w.globals.seriesTotals.reduce((a, b) => {
                return a + b
              }, 0)
              const x = sum === 0 ? 0 : Math.round((val / sum) * 100)
              return `${x}%`
            }
          }
        },
        chart: {
          offsetY: 80,
          type: 'donut',
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          pie: {
            customScale: 1.0,
            donut: {
              labels: {
                show: true,
                name: { show: true },
                value: { show: true },
                total: {
                  showAlways: true,
                  label: 'Northern',
                  show: true
                }
              }
            }
          }
        },
        stroke: { width: 0 }
      },
      cchartOptions: {
        labels: [],
        colors: ['#008cff', '#28C76F', '#EA5455', '#7193FF', '#FF9F43', '#e5ff00', '#1E1E1E', '#4b9484', '#af9d6a'],
        dataLabels: {
          enabled: false
        },
        legend: { show: true, position: 'bottom' },
        tooltip: {
          y: {
            formatter(val, w) {
              const sum = w.globals.seriesTotals.reduce((a, b) => {
                return a + b
              }, 0)
              const x = sum === 0 ? 0 : Math.round((val / sum) * 100)
              return `${x}%`
            }
          }
        },
        chart: {
          offsetY: 80,
          type: 'donut',
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          pie: {
            customScale: 1.0,
            donut: {
              labels: {
                show: true,
                name: { show: true },
                value: { show: true },
                total: {
                  showAlways: true,
                  label: 'Central',
                  show: true
                }
              }
            }
          }
        },
        stroke: { width: 0 }
      },
      tkchartOptions: {
        labels: [],
        colors: ['#008cff', '#28C76F', '#EA5455', '#7193FF', '#FF9F43', '#e5ff00',  '#1E1E1E', '#4b9484', '#af9d6a'],
        dataLabels: {
          enabled: false
        },
        legend: { show: true, position: 'bottom' },
        tooltip: {
          y: {
            formatter(val, w) {
              const sum = w.globals.seriesTotals.reduce((a, b) => {
                return a + b
              }, 0)
              const x = sum === 0 ? 0 : Math.round((val / sum) * 100)
              return `${x}%`
            }
          }
        },
        chart: {
          offsetY: 80,
          type: 'donut',
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          pie: {
            customScale: 1.0,
            donut: {
              labels: {
                show: true,
                name: { show: true },
                value: { show: true },
                total: {
                  showAlways: true,
                  label: 'Western',
                  show: true
                }
              }
            }
          }
        },
        stroke: { width: 0 }
      },
      start: '2020-03-01',
      end: new Date().toISOString().slice(0, 10),
      isLoadingG: false,
      isLoadingA: false,
      isLoadingK: false,
      isLoadingT: false,
      isLoadingC: false,
      isLoadingTK: false
    }
  },
  created() {
    this.getStrains()
  },
  methods: {
    getStrains() {
      const self = this
      this.strains = []
      covidApi
        .strains()
        .then(response => {
          self.strains = response.data
          self.getData()
        })
        .catch(error => {
          console.log(error)
        })
    },
    getData() {
      const self = this
      this.gseries = []
      this.aseries = []
      this.kseries = []
      this.tseries = []
      this.cseries = []
      this.tkseries = []
      this.isLoadingG = true
      this.isLoadingA = true
      this.isLoadingK = true
      this.isLoadingT = true
      this.isLoadingC = true
      this.isLoadingTK = true
      covidApi
        .bigpie({ region: 'Eastern', start: this.start, end: this.end })
        .then(response => {
          self.gseries = response.data.series
          self.gchartOptions = {
            ...self.gchartOptions,
            labels: self.strains
          }
          this.isLoadingG = false
        })
        .catch(error => {
          console.log(error)
        })

      covidApi
        .bigpie({ region: 'Greater Accra', start: this.start, end: this.end })
        .then(response => {
          self.aseries = response.data.series
          self.achartOptions = {
            ...self.achartOptions,
            labels: self.strains
          }
          this.isLoadingA = false
        })
        .catch(error => {
          console.log(error)
        })

      covidApi
        .bigpie({ region: 'Ashanti', start: this.start, end: this.end })
        .then(response => {
          self.kseries = response.data.series
          self.kchartOptions = {
            ...self.kchartOptions,
            labels: self.strains
          }
          this.isLoadingK = false
        })
        .catch(error => {
          console.log(error)
        })

      covidApi
        .bigpie({ region: 'Northern', start: this.start, end: this.end })
        .then(response => {
          self.tseries = response.data.series
          self.tchartOptions = {
            ...self.tchartOptions,
            labels: self.strains
          }
          self.isLoadingT = false
        })
        .catch(error => {
          console.log(error)
        })

      covidApi
        .bigpie({ region: 'Western', start: this.start, end: this.end })
        .then(response => {
          self.tkseries = response.data.series
          self.tkchartOptions = {
            ...self.tkchartOptions,
            labels: self.strains
          }
          self.isLoadingTK = false
        })
        .catch(error => {
          console.log(error)
        })

      covidApi
        .bigpie({ region: 'Central', start: this.start, end: this.end })
        .then(response => {
          self.cseries = response.data.series
          self.cchartOptions = {
            ...self.cchartOptions,
            labels: self.strains
          }
          self.isLoadingC = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    periodChanged(args) {
      this.start = args.start
      this.end = args.end
      //console.log(`Start: ${this.start} End: ${this.end}`)
      this.getData()
    }
  }
}
</script>
